import { RootState } from "@/store/store";
import {
  selectPanoCameraTransform,
  type MapWaypoint,
} from "@/utils/camera-transform";
import { selectAncestor } from "@faro-lotv/app-component-toolbox";
import {
  IElementGenericImgSheet,
  isIElementSectionGeoslam,
} from "@faro-lotv/ielement-types";
import { Vector3 } from "three";

/**
 * @returns a good camera position to use when moving to model rendering from a 360
 * @param pano the active 360 before we move to model rendering
 * @param sheetForElevation to project 360s without a valid height
 */
export function selectBestModelCameraFor360(
  pano: MapWaypoint,
  sheetForElevation: IElementGenericImgSheet | undefined,
) {
  return (state: RootState): Vector3 => {
    const { position } = selectPanoCameraTransform(
      pano,
      sheetForElevation,
    )(state);

    // If it's a geoslam pano, just pick the pano position and adds 50cm vertically
    // TODO: generalize this code once the info is provided by the backend https://faro01.atlassian.net/browse/SWEB-2533
    const extraHeight = selectAncestor(pano, isIElementSectionGeoslam)(state)
      ? 0.5
      : 0;

    return new Vector3(position[0], position[1] + extraHeight, position[2]);
  };
}
